<script setup>
const props = defineProps({
    id: {
        type: [String, Boolean],
        required: false,
        default: false,
    },
    type: {
        type: [String, Boolean],
        required: false,
        default: 'none',
    },
});
</script>

<template>
    <component v-if="type != 'none'" :is="type" :id="id || null" :data-type="type" class="mess-svg" />
</template>
